import _app from '../../../server';

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
    summons__getById,
    summons__detailFineCommit,
    summons_approve,
    summon_archive
} from 'redux/actions/summons'

import {
    Alert,
    Button,
    Card, CardBody,
    Row,
    Form, FormGroup,
    Input, InputGroup, InputGroupAddon,
    FormFeedback
} from 'reactstrap';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const moment = require('moment');


class TxEditor extends Component {
    static propTypes = {
        auth: PropTypes.object,
        summon: PropTypes.object,
        transactions: PropTypes.array,
        dispatch: PropTypes.func,
        location: PropTypes.object,

    }

    constructor(props) {
        super(props);
        this.state = {
            fineInvalid: false,
            fineValid: false,
            fineErr: '',
            remark: '',
            remarkInvalid: false,
            remarkErr: '',
            reasonValid: false,
            reasonInvalid: false,
            reasonErr: '',
            reason: '',
            editColor: 'success',
            editOpen: false,
            editFeedback: ''

        }
    }
    onFineDismiss = () => { this.setState({ fineInvalid: false, fineValid: false, fineErr: '' }) }
    onEditDismiss = () => { this.setState({ editOpen: false }) }
    onRemarkDismiss = () => { this.setState({ remarkInvalid: false, remarkErr: '' }) }

    onRemarkChange = (e) => { this.setState({ remark: e.target.value }) }
    onReasonChange = (e) => { this.setState({ reason: e.target.value }) }
    onFineChangeCommit = (e) => {
        const { dispatch, summon } = this.props
        dispatch(summons__detailFineCommit(summon.id, e.target.value))
    }

    onEdit = () => {
        const { dispatch, summon } = this.props
        const { reason } = this.state

        const { fine } = summon;

        if (fine === '' || fine === 0 || fine === '0') {
            this.setState({ fineInvalid: true, fineErr: 'Please enter amount to be fined' })
            return
        }

        if (reason === '') {
            this.setState({ reasonInvalid: true, reasonErr: 'This field is required' })
            return
        }

        confirmAlert({
            title: 'Confirm to accept',
            message: `Fine RM ${fine}`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => { dispatch(summons_approve(summon.id, fine, reason, this.onEditErr)) }
                },
                {
                    label: 'No'
                }
            ]
        });
    }
    onEditErr = (e) => {
        const { dispatch, summon } = this.props

        if (!e) {
            this.setState({ editOpen: true, editColor: 'success', editFeedback: `Compounds successfully modified` })
            dispatch(summons__getById(summon.id))
            return;
        }
        this.setState({ editOpen: true, editColor: 'danger', editFeedback: `${e.name} : ${e.message}` })
    }


    onArchive = () => {
        const { dispatch, summon } = this.props
        const { remark } = this.state

        if (remark === '') {
            this.setState({ remarkInvalid: true, remarkErr: 'Please enter the reason' })
            return;
        }
        confirmAlert({
            title: 'Confirm to archived',
            message: `Permanently move the record to archive`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => { dispatch(summon_archive(summon.id, remark, this.onArchiveError)) }
                },
                {
                    label: 'No'
                }
            ]
        });

    }
    onArchiveError = (err) => {
        const { history } = this.props
        if (!err) {
            history.replace('/traffic/verified')
            return;
        }
        this.setState({ remarkInvalid: true, remarkErr: `${err.name} : ${err.message}` })
    }


    render() {

        const { auth, transactions, summon } = this.props;
        const { fine } = summon;

        let flip = false;
        let log = transactions.map((log) => {
            let clr = 'text-primary'
            if (flip) {
                clr = 'text-muted'
            }
            flip = !flip
            return (
                <CardBody key={log.id} className="bg-transparent border-l-2 p-0 pl-2">
                    <div className={clr}><b>{log.summoner.name}</b>{'\u00A0'}<span><small>{moment(log.timestamp).format("YYYY/MM/DD hh:mm:ss A")}</small></span></div>
                    <small>{log.summoner.staffId} : {log.summoner.email} / {log.summoner.phoneNumber}</small>
                    <hr />
                    <CardBody style={{ marginLeft: '20px', paddingTop: '0px' }}>
                        {log.remark}
                    </CardBody>
                </CardBody>
            )
        })

        return (
            <React.Fragment>
                <Card className="bg-transparent border-0">
                    <CardBody>
                        <Row>
                            <div className="font-2xl display-4 text-muted font-italic ml-2 mb-3 text-left">Log:</div>
                        </Row>
                        {transactions.length < 1 &&
                            <p>No transaction record available</p>
                        }
                        {transactions.length > 0 && log}
                    </CardBody>
                </Card>
                <hr />
                {(_app.dashboard !== auth.info.profile.email) &&
                    <React.Fragment>
                        <Form onSubmit={(e) => { e.preventDefault() }} className="w-75 m-auto">
                            <FormGroup>
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        <Button disabled style={{ minWidth: '100px' }}>Fine (RM)</Button>
                                    </InputGroupAddon>
                                    <Input type='number' valid={this.state.fineValid} invalid={this.state.fineInvalid} value={fine} onChange={this.onFineChangeCommit} onFocus={this.onFineDismiss}></Input>
                                    <FormFeedback onClick={this.onFineDismiss} valid className="text-center" style={{ backgroundColor: 'white' }}>{this.state.fineErr}</FormFeedback>
                                    <FormFeedback onClick={this.onFineDismiss} className="text-center" style={{ backgroundColor: 'white' }}>{this.state.fineErr}</FormFeedback>
                                </InputGroup>
                                <br />
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        <Button disabled style={{ minWidth: '100px' }}>Reason</Button>
                                    </InputGroupAddon>
                                    <Input valid={this.state.reasonValid} invalid={this.state.reasonInvalid} value={this.state.reason} onChange={this.onReasonChange} onFocus={this.onReasonDismiss}></Input>
                                    <FormFeedback onClick={this.onReasonDismiss} valid className="text-center" style={{ backgroundColor: 'white' }}>{this.state.reasonErr}</FormFeedback>
                                    <FormFeedback onClick={this.onReasonDismiss} className="text-center" style={{ backgroundColor: 'white' }}>{this.state.reasonErr}</FormFeedback>
                                </InputGroup>
                            </FormGroup>
                            <div className='text-right'>
                                <Button onClick={this.onEdit} size='md' color='dark' className="filter-toggler">Submit</Button>
                                <Alert color={this.state.editColor} isOpen={this.state.editOpen} toggle={this.onEditDismiss} className="text-center mt-1">
                                    {this.state.editFeedback}
                                </Alert>
                            </div>
                            <br />
                            <hr />
                        </Form>
                        <Form onSubmit={(e) => { e.preventDefault() }} className="w-75 m-auto">
                            <FormGroup>
                                <InputGroup size='sm' style={{ minWidth: '100px' }}>
                                    <InputGroupAddon addonType="prepend">
                                        <Button disabled style={{ minWidth: '100px' }}>Remark</Button>
                                    </InputGroupAddon>
                                    <Input invalid={this.state.remarkInvalid} value={this.state.remark} onChange={this.onRemarkChange} onFocus={this.onRemarkDismiss}></Input>
                                    <InputGroupAddon addonType="append">
                                        <Button onClick={this.onArchive} color='danger' style={{ minWidth: '100px' }}>Archive</Button>
                                    </InputGroupAddon>
                                    <FormFeedback onClick={this.onRemarkDismiss} valid className="text-center" style={{ backgroundColor: 'white' }}>{this.state.remarkErr}</FormFeedback>
                                    <FormFeedback onClick={this.onRemarkDismiss} className="text-center" style={{ backgroundColor: 'white' }}>{this.state.remarkErr}</FormFeedback>
                                </InputGroup>
                            </FormGroup>
                        </Form>
                    </React.Fragment>
                }
            </React.Fragment>
        )

    }
}

export default TxEditor



// WEBPACK FOOTER //
// ./src/components/features/TxEditor/TxEditor.js